import type { PluginRouteFactory } from "@d12labs/plugins/types";
import { createRoute } from "@tanstack/react-router";
import { lazy } from "react";

const UploadsPage = lazy(() =>
	import("./pages/uploads.page").then((m) => ({ default: m.UploadsPage })),
);

export const createPluginRoutes: PluginRouteFactory = (parentRoute) =>
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/uploads",
		component: UploadsPage,
	});
